import { observer } from 'mobx-react-lite';
import { Icon, Menu } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
interface Props {
  options: any;
  L2Labels: string;
}

function StepL3ForInventory({ options, L2Labels }: Props) {
  const {
    dashboardStore,
    userStore: { user },
    commonStore,
  } = useStore();

  useEffect(() => {
    for (let i = 0; i <= options.length; i++) {
      if (
        !commonStore.filterModeTwo?.includes(options?.[i]?.id) &&
        !commonStore.filterModeZero?.includes(options?.[i]?.id)
      ) {
        if (L2Labels === 'Receiving') {
          dashboardStore.openL2ForInventory(L2Labels, options?.[i]?.value);
        } else if (L2Labels === 'Delivery') {
          dashboardStore.openL2ForInventory(L2Labels, options?.[i]?.value);
        } else if (L2Labels === 'Reports') {
          dashboardStore.openL2ForInventory(L2Labels, options?.[i]?.value);
        } else {
          dashboardStore.openL2ForInventory('', '');
        }
        break;
      }
    }
    // eslint-disable-next-line
  }, [options]);

  return (
    <div style={{ marginTop: '-10px' }}>
      <Menu style={{ height: '50px' }} widths={options?.length}>
        {options?.map((a: any) =>
          commonStore.filterModeTwo.includes(a.id) ? (
            <></>
          ) : (
            <Menu.Item
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgba(240,240,290,1) ${
                  a.gradientvalue
                }%, rgba(255,255,255,1)${a.gradientvalue + 10}%)`,
              }}
              onClick={() => dashboardStore.openL3ForInventory(a.value)}
              disabled={commonStore.filterModeZero?.includes(`${a.id}`)}
            >
              <p
                className={
                  dashboardStore.dashboard.valueForL3Inventory === a.value &&
                  dashboardStore.dashboard.onFirstLoadNoTransition
                    ? 'inventorylevel2dark'
                    : dashboardStore.dashboard.valueForL3Inventory ===
                          a.value && dashboardStore.dashboard.setfadeIn
                      ? 'InventoryL3fadeIn'
                      : dashboardStore.dashboard.valueForL3Inventory ===
                            a.value &&
                          dashboardStore.dashboard.setfadeIn === false
                        ? 'InventoryL3fadeOut'
                        : 'inventorylevel2light'
                }
                style={{
                  marginTop: '18px',
                  fontSize: '13px',
                  fontWeight: 'bold',
                }}
              >
                {' '}
                <Icon size="big" name={a.Icon} />{' '}
                {a?.value === 'Create Order Receiving'
                  ? (userLanguage[0].Level3InventoryRecievingRegister.IRRL04 as any)?.[
                    `${commonStore.language.key}`
                  ]
                  : a.value === 'Create Order Receiving' &&
                      user?.customerName === 'LVPCMS'
                    ? 'Film Festival Submission'
                    : user?.customerName === 'PCPLCRM' && user?.roleName.trim() === 'CRM' ? 'MIS Creation'
                    : a.text[`${commonStore.language.key}`]}
                {a.number}
              </p>
              <Icon />
            </Menu.Item>
          ),
        )}
      </Menu>
    </div>
  );
}

export default observer(StepL3ForInventory);
